import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const [parallaxOffset, setParallaxOffset] = useState(0);
  const heroRef = useRef<HTMLElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      const rect = heroRef.current.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const scrollProgress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        setParallaxOffset(scrollProgress * 120);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      ref={heroRef}
      className="relative min-h-[85vh] md:min-h-[90vh] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 -top-[15%] -bottom-[15%]">
        <div
          className="absolute inset-0 transition-transform duration-75 ease-linear"
          style={{ transform: `translateY(${parallaxOffset}px)` }}
        >
          <img
            src="https://readdy.ai/api/search-image?query=Black%20African%20telecom%20engineers%20and%20technicians%20with%20dark%20skin%20installing%20cellular%20antennas%20and%20microwave%20equipment%20on%20a%20modern%20telecommunications%20tower%20in%20Africa%2C%20professional%20dark-skinned%20crew%20working%20at%20height%20with%20safety%20harnesses%2C%20clear%20blue%20sky%20background%2C%20bright%20daylight%20industrial%20photography%20with%20dramatic%20wide%20angle%20perspective%20showing%20the%20tower%20scale&width=1920&height=1080&seq=hero-tel-main-01&orientation=landscape&nocache=true"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/65"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-24 md:pt-32">
        <div className="bg-black/40 backdrop-blur-md rounded-2xl px-6 py-6 md:px-10 md:py-10 inline-block">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-white mb-5 leading-[1.1] drop-shadow-lg">
          {t('hero.titleLine1')}<br />
          <span className="text-accent-400">{t('hero.titleLine2')}</span><br />
          {t('hero.titleLine3')}
        </h1>

          <p className="text-lg md:text-xl text-white/95 mb-8 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
          {t('hero.subtitle')}
        </p>

        <Link
          to="/devis"
          className="inline-flex items-center gap-3 bg-accent-500 hover:bg-accent-600 text-background-950 px-8 py-4 rounded-full text-base md:text-lg font-semibold transition-all cursor-pointer whitespace-nowrap animate-pulse-glow"
        >
          {t('hero.cta')}
          <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
        </Link>
      </div>
    </div>
    </section>
  );
}